import { createRoutine } from 'redux-saga-routines'

export const LIST = "bCard.List";

export const getRecords = createRoutine(LIST);
